import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { Filter } from '@brafton/angular-framework-library';

@Component({
  selector: 'shared-filter-panel-units',
  templateUrl: './filter-panel-units.component.html',
  styleUrls: ['./filter-panel-units.component.scss'],
  host: { class: 'filter-panel-units' },
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SharedFilterPanelUnitsComponent implements OnInit {
  @Input() units: Filter[] = [];
  @Output() unitsChange: EventEmitter<Filter[]> = new EventEmitter<Filter[]>();
  @Output() close: EventEmitter<any> = new EventEmitter();

  constructor() {}

  unitOptions!: any[];

  ngOnInit() {
    this.loadUnitOptions();
  }

  addProduct(statusDef: any) {
    if (!this.units.find((sp) => sp.value === statusDef.id)) {
      this.units.push({ value: statusDef.id, displayName: statusDef.displayName, type: 'unit' } as Filter);
    }
    this.unitsChange.emit(this.units);
  }

  removeProduct(statusDef: any) {
    const index = this.units.findIndex((sp) => sp.value === statusDef.id);
    if (index > -1) {
      this.units.splice(index, 1);
    }
    this.unitsChange.emit(this.units);
  }

  clear() {
    this.units = [];
    this.unitsChange.emit(this.units);
  }

  isSelected(statusDef: any): boolean {
    if (!this.units) return false;
    if (this.units.find((sp) => sp.value === statusDef.id)) return true;
    else return false;
  }

  loadUnitOptions() {
    this.unitOptions = [{ id: 'true', displayName: 'Has Units' }];
  }
}
